import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SkeletonModule} from 'primeng/skeleton';
import {TooltipModule} from 'primeng/tooltip';
import {EventSummaryApiModel} from '../../../api/models/event.api.model';
import {formatEventLocation} from '../event-location.util';

@Component({
  selector: 'app-event-card-summary',
  standalone: true,
  imports: [CommonModule, SkeletonModule, TooltipModule],
  templateUrl: './event-card-summary.component.html',
  styleUrls: ['./event-card-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventCardSummaryComponent {
  @Input() public event: EventSummaryApiModel;
  @Input() public placeholder = false;

  public get location(): string {
    return formatEventLocation(this.event);
  }

  public get firstDate(): NonNullable<EventSummaryApiModel['eventDates']>[number] | undefined {
    return this.event?.eventDates?.[0];
  }

  public get lastDate(): NonNullable<EventSummaryApiModel['eventDates']>[number] | undefined {
    return this.event?.eventDates?.[this.event.eventDates.length - 1];
  }
}
